module.exports = __webpack_public_path__ + "img/bab2t3.22487015.png";